import { render } from "./PredictionHistory.vue?vue&type=template&id=f0ed4ade"
import script from "./PredictionHistory.vue?vue&type=script&lang=js"
export * from "./PredictionHistory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__